import { Enum } from './common';

type ENV_VARS = Enum<typeof ENV_VARS>;
const ENV_VARS = Enum(
  'REACT_APP_API_URL',
  'REACT_APP_AUTHENTICATION_CLIENT_ID',
  'REACT_APP_AUTHENTICATION_CLIENT_SECRET',
  'REACT_APP_AUTHENTICATION_API_URL',
  'REACT_APP_AUTHENTICATION_API_SCOPE_URL',
  'REACT_APP_ENV'
);

type Env = {
  [key in ENV_VARS]: string;
};

export const getEnv = (): Env => {
  return Object.keys(ENV_VARS).reduce((obj, value) => ({ ...obj, [value]: process.env[value] || '' }), {} as Env);
};
